import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { playSound } from 'containers/App/actions';
import { makeSelectCasinoSoundsOn } from 'containers/App/selectors';
import withSoundLoader from 'utils/withSoundLoader';
import dailyBonusPop from './sounds/DailyBonus_Pop.mp3';
import dailyBonusVisible from './sounds/DailyBonus_PopupSound.mp3';

export const DAILY_BONUS_VISIBLE = 'dailyBonusVisible';
export const DAILY_BONUS_POP = 'dailyBonusPop';

const DAILY_BONUS_SOUNDS = {
  [DAILY_BONUS_VISIBLE]: {
    src: [dailyBonusVisible],
    volume: 1
  },
  [DAILY_BONUS_POP]: {
    src: [dailyBonusPop],
    volume: 1
  }
};

function withDailyBonusSounds(WrappedComponent) {
  class Sounds extends Component {
    render() {
      const { triggerSound, casinoSoundsOn, ...otherProps } = this.props;

      return (
        <WrappedComponent
          playBonusVisible={() => {
            if (casinoSoundsOn) triggerSound(DAILY_BONUS_VISIBLE);
          }}
          playBonusPop={() => {
            if (casinoSoundsOn) triggerSound(DAILY_BONUS_POP);
          }}
          {...otherProps}
        />
      );
    }
  }

  Sounds.propTypes = {
    triggerSound: PropTypes.func,
    casinoSoundsOn: PropTypes.bool
  };

  function mapDispatchToProps(dispatch) {
    return {
      triggerSound: sound => dispatch(playSound(sound))
    };
  }

  const mapStateToProps = createStructuredSelector({
    casinoSoundsOn: makeSelectCasinoSoundsOn()
  });

  const withConnect = connect(mapStateToProps, mapDispatchToProps);
  const withWheelSoundLoader = withSoundLoader(DAILY_BONUS_SOUNDS, true);

  return withConnect(withWheelSoundLoader(Sounds));
}

export default withDailyBonusSounds;
